import { render, staticRenderFns } from "./EditPostDropZone.vue?vue&type=template&id=2aac4910&scoped=true&"
import script from "./EditPostDropZone.vue?vue&type=script&lang=ts&"
export * from "./EditPostDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./EditPostDropZone.vue?vue&type=style&index=0&id=2aac4910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac4910",
  null
  
)

export default component.exports